/* eslint-disable no-useless-concat */
import { CustomTitle } from "./CustomTitle"
import { css } from "@emotion/css"

import { useI18n } from "providers/I18n"

import { BaseTable } from "../../SharedComponents/BaseTable"
import { Loading } from "components/Loading"
import { Box } from "@material-ui/core"
import { nonGCFRow } from "../../../tablesInfoData/tableRows"
import { ContentLayout } from "../../SharedComponents/ContentLayout"
import { standardScrollBar } from "../../../styles"
import { DetailsNonGCFData, NonGCFData } from "../../../types"

const styles = {
  footerContainer: css`
    padding: 8px 0px;
    background-color: var(--extra-dark-grey);
  `,
  tablebox: css`
    margin-top: var(--spacing-xl);
  `,
  totalText: css`
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
  `,
  drillDownTitle: css`
    ::first-letter {
      text-transform: capitalize;
    }
    margin-bottom: 24px;
    color: var(--white);
    font-size: 18px;
  `,
}

type TableProps = {
  data: NonGCFData | undefined
  item: {
    key: string
    value: [] | DetailsNonGCFData[]
  }

  customTitles: { text: string; dataLength: number }[]
  isLoading: boolean
}
export function NonGCFTable(props: TableProps) {
  const { t } = useI18n()

  const { data, item, isLoading, customTitles } = props

  const columnWidth = 465
  const headersGapWidth = 24

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <Box
        style={{ width: "100%", overflow: "auto" }}
        className={standardScrollBar.root}
      >
        <Box
          display="flex"
          style={{ gap: headersGapWidth, width: "fit-content" }}
        >
          <CustomTitle title="" hideBorder customWidth={84} />
          {customTitles.map((t, index) => {
            return (
              <CustomTitle
                key={index}
                title={<div>{t.text}</div>}
                customWidth={
                  t.dataLength === 4 ? columnWidth * 0.79 : columnWidth
                }
              />
            )
          })}
        </Box>
        <ContentLayout maxHeight="500px" customClass={styles.tablebox}>
          <BaseTable
            rows={nonGCFRow(t, item.key)}
            data={data?.data[item.key as keyof typeof data.data]}
            isLoading={isLoading}
            columnWidth={columnWidth + headersGapWidth}
            gap={headersGapWidth}
            cellsPerColumn={5}
            total={data?.total[item.key as keyof typeof data.data]}
          />
        </ContentLayout>
      </Box>
    </>
  )
}
